import React from 'react';
import { ILinkedIconModuleProps, IPreviewTileProps } from '../../../interfaces/interfaces';
import DummyIcon from '../../elements/Icons/DummyIcon';

function LinkedIconPreview(props: ILinkedIconModuleProps & IPreviewTileProps): JSX.Element {
  const { badgeText, iconUrl } = props;
  return (
    <>
      <div className="preview">
        <div className="icon">
          {iconUrl ? <img src={iconUrl} alt="NO ICON" style={{ width: '100%', height: '90px' }} /> : <DummyIcon />}
        </div>

        {badgeText && <span className="marker">{badgeText}</span>}
      </div>
    </>
  );
}
export default LinkedIconPreview;
